import React from "react";
import Checkbox from "@material-ui/core/Checkbox";
import InputLabel from "@material-ui/core/InputLabel";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import FormHelperText from "@material-ui/core/FormHelperText";
import Select from "@material-ui/core/Select";
import { Row, Col } from "react-bootstrap";
import Tooltip from '@material-ui/core/Tooltip';
import InfoIcon from '@material-ui/icons/Info';
import PropTypes from 'prop-types';

const MenuProps = {
    getContentAnchorEl: null,
    anchorOrigin: {
        vertical: "bottom",
        horizontal: "center"
    },
    transformOrigin: {
        vertical: "top",
        horizontal: "center"
    },
    variant: "menu"
};

export default function MultiSelectInput(props) {

    const { errors, selectOptions, id, variant, helpText, inputColumnSize, value, ...textFieldProps } = props;

    const columnSize = inputColumnSize || 12;

    const menuItems = selectOptions && selectOptions.map((option, key) => {
        return <MenuItem className="p-0" key={key + 1} value={option.value} disabled={option.disabled}>
            <ListItemIcon className="mr-n3">
                <Checkbox className="py-1" checked={value.indexOf(option.value) > -1} color="primary" />
            </ListItemIcon>
            <ListItemText className="mr-3" primary={option.label} />
        </MenuItem>
    });

    return (
        <Row>
            <Col xs={columnSize}>
                <FormControl fullWidth variant={variant || "filled"} error={!!errors}>
                    <InputLabel htmlFor={id}>{props.label}</InputLabel>
                    <Select
                        multiple
                        value={value}
                        renderValue={() => value.join(', ')}
                        MenuProps={MenuProps}
                        inputProps={{ id: id }}
                        {...textFieldProps}
                        fullWidth
                    >
                        {menuItems}
                    </Select>
                    <FormHelperText id={`${id}-helper-text`} aria-describedby={`${id}-helper-text`}>{errors && errors.message}</FormHelperText>
                </FormControl>
            </Col>

            {helpText &&
                <Col xs={2}>
                    <div className="d-flex mt-2">
                        <Tooltip title={helpText}>
                            <InfoIcon color="action"></InfoIcon>
                        </Tooltip>
                    </div>
                </Col>
            }
        </Row>
    );
}

MultiSelectInput.propTypes = {
    id: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    selectOptions: PropTypes.arrayOf(PropTypes.shape({
        value: PropTypes.any.isRequired,
        label: PropTypes.any.isRequired,
        disabled: PropTypes.bool,
    })).isRequired,
    label: PropTypes.string,
    name: PropTypes.string.isRequired,
    value: PropTypes.any.isRequired,
    variant: PropTypes.string,
    errors: PropTypes.object,
    helpText: PropTypes.string
}


// WEBPACK FOOTER //
// ./src/components/Helpers/Inputs/MultiSelectInput.js